var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filtroExtrato',{on:{"filtro":_vm.makeFiltro}}),_c('ListExtrato',{attrs:{"subjectPermission":_vm.subjectPermission,"filtro":_vm.filtro,"realizarFiltro":_vm.realizarFiltro},on:{"finalizarFiltro":_vm.finalizarFiltro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }